module.exports = __webpack_public_path__ + "img/2.50e8220c.jpg";